import { useFetch } from "@hooks/useFetch";
import { EEirSalesSimType, getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { getInclusiveEquipmentsApiRoute } from "@api-routes/eirSalesFacade";
import { ICart } from "@features/cart/ICart";
import { mapInclusiveEquipmentPayload } from "@mappers/postInclusiveEquipmentsMapper";

interface IParams {
    setCart: (cart: ICart) => void;
}

export const usePostInclusiveEquipments = (props: IParams) => {
    const { setCart } = props;

    const [postInclusiveEquipmentState, { post }] = useFetch();

    const postInclusiveEquipment = async (offerId: number, simCardType: EEirSalesSimType) => {
        await post<ICartResponse>(getInclusiveEquipmentsApiRoute(offerId), {
            body: mapInclusiveEquipmentPayload(simCardType),
        })
            .then((inclusiveEquipmentResponse) => {
                if (inclusiveEquipmentResponse) {
                    const newCart = getResponseToState(inclusiveEquipmentResponse);

                    setCart(newCart);

                    return newCart;
                }

                return undefined;
            })
            .catch(() => {
                return undefined;
            });
    };

    return { postInclusiveEquipmentState, postInclusiveEquipment };
};
